import {useList} from "@refinedev/core"
import IClient from "../interfaces/IClient"

export const CLIENTS_RESOURCE = 'client'

export function getClients() {
    const {data: clientsData, isLoading: isClientsLoading, error: clientsError} = useList<IClient>({
        resource: CLIENTS_RESOURCE,
        meta: {resourceName: 'clients'}
    })
    return {clients: clientsData?.data ?? [], isClientsLoading, clientsError}
}
